import { useQuery } from '@tanstack/react-query';
import { fetchPosProducts, PagedResult } from '../Services/PosProductApi';
import { PointOfSaleProductEntity } from 'Models/Entities';
import { posProductKeys } from './posProductKeys';

export const usePosProductList = (page = 1, pageSize = 20) => {
	return useQuery<PagedResult<PointOfSaleProductEntity>, Error>({
		queryKey: posProductKeys.list({ page, pageSize }),
		queryFn: () => fetchPosProducts(page, pageSize),
	});
};
